import { useState } from "react";

const submitAddr = "https://readdy.ai/api/form/da2mq1jd3r93mn1k3c80";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐检测：若被自动填充，则静默返回成功提示
    const hp = (data.get("website_alt") as string) ?? "";
    if (hp.trim()) {
      setStatus("success");
      form.reset();
      return;
    }

    // 构造提交数据
    data.delete("website_alt");
    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (value instanceof File) return;
      payload.append(key, String(value));
    });

    setStatus("idle");
    try {
      const res = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam = /spam|form data is spam/i.test(
        `${responseText} ${serverMsg}`,
      );
      const codeOk = res.ok && parsed?.code === "OK";

      if (isSpam) {
        setStatus("error");
        setFormError(serverMsg || "提交内容未通过校验，请重新填写。");
        return;
      }
      if (!codeOk) {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
        return;
      }
      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section className="relative overflow-hidden bg-primary-500 py-16 md:py-20">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=subtle%20warm%20comic%20ink%20brush%20stroke%20texture%20pattern%20background%20in%20deep%20crimson%20and%20gold%2C%20abstract%20artistic%20flow%2C%20no%20text&width=1600&height=500&seq=jm-sub&orientation=landscape"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <div className="relative mx-auto max-w-3xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-mail-send-line text-accent-200"></i>
          订阅静漫天堂
        </span>
        <h2 className="mt-5 font-heading text-3xl text-background-50 md:text-4xl">
          不错过任何高清更新
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-50/80">
          订阅后你将定期收到画质精选推荐、新作上线提醒与专题整理，第一时间发现值得收藏的高清静态漫画图源。
        </p>

        {status === "success" ? (
          <div className="mx-auto mt-8 flex max-w-md items-center justify-center gap-2 rounded-2xl bg-background-50/15 px-6 py-4 text-sm text-background-50 backdrop-blur-sm">
            <i className="ri-checkbox-circle-line text-accent-200"></i>
            订阅成功，感谢你的支持，我们很快会与你联系。
          </div>
        ) : (
          <form
            data-readdy-form="静漫天堂订阅表单"
            onSubmit={handleSubmit}
            className="mx-auto mt-8 flex max-w-lg flex-col gap-3 rounded-2xl bg-background-50/15 p-3 backdrop-blur-md sm:flex-row sm:items-center sm:rounded-full"
          >
            <input
              type="text"
              name="website_alt"
              aria-hidden="true"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              className="jm-meta-field"
            />
            <i className="ri-mail-line pl-3 text-lg text-background-50/80"></i>
            <input
              type="email"
              name="email"
              required
              placeholder="输入你的邮箱地址"
              aria-label="邮箱地址"
              className="w-full bg-transparent py-2 text-sm text-background-50 outline-none placeholder:text-background-50/60"
            />
            <button
              type="submit"
              className="shrink-0 rounded-full bg-accent-500 px-6 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="mx-auto mt-4 max-w-md rounded-lg bg-background-50/15 px-4 py-2 text-xs text-background-50">
            {formError}
          </p>
        )}
      </div>
    </section>
  );
}